module.exports = __webpack_public_path__ + "img/Doctor-pana 1.3f8efba5.svg";